import {
    Accordion as MUIAccordion,
    AccordionDetails as MUIAccordionDetails,
    AccordionSummary as MUIAccordionSummary,
    styled,
} from '@mui/material';
import { forwardRef } from 'react';

import Icon from 'shell/components/Icon';

const CustomIcon = styled(Icon)(() => {
    return {
        fontSize: '1.25rem',
    };
});

const CustomAccordion = styled(MUIAccordion)(() => {
    return {
        boxShadow: 'none !important',
        '&.Mui-expanded': {
            margin: 0,
        },
        '&::before': {
            display: 'none',
        },
    };
});

const CustomAccordionSummary = styled(MUIAccordionSummary)(({ theme }) => {
    return {
        display: 'flex',
        gap: theme.spacing(1),
        margin: '0 !important',
        minHeight: 'unset',
        padding: 0,
        userSelect: 'text',
        '&:focus-visible': {
            borderRadius: '6px',
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        },
        '&.Mui-expanded': {
            minHeight: 'unset',
        },
        '& > .MuiAccordionSummary-content': {
            margin: 0,
        },
    };
});

const CustomAccordionDetails = styled(MUIAccordionDetails)(() => {
    return {
        padding: 0,
    };
});

const Accordion = forwardRef(({ ...rest }, ref) => {
    return <CustomAccordion ref={ref} {...rest} />;
});

const AccordionSummary = forwardRef(({ ...rest }, ref) => {
    return (
        <CustomAccordionSummary
            ref={ref}
            expandIcon={<CustomIcon kind={'dropdownArrowDown'} />}
            {...rest}
            aria-expanded={undefined}
        />
    );
});

const AccordionDetails = forwardRef(({ ...rest }, ref) => {
    return <CustomAccordionDetails ref={ref} {...rest} />;
});

export { Accordion, AccordionDetails, AccordionSummary };
